export default "__VITE_ASSET__DBOIjOp5__"